module.exports = __webpack_public_path__ + "static/media/loading_mobile.08644281.gif";